import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import styled from 'styled-components';
import { useSelector } from 'react-redux';

import RequiredAsterisk from '../RequiredAsterisk';
import SocialRsvpRequiredMessage from './SocialRsvpRequiredMessage';
import { getFormMetaFromId } from '../../../../selectors/form';
import FormErrorWithIcon from '../../../errors/FormErrorWithIcon';
import Facebook from './Facebook';
import LinkedIn from './LinkedIn';

const LINKEDIN_OPTION = 'linkedIn';
const FACEBOOK_OPTION = 'facebook';

const requiredMessages = {
    [LINKEDIN_OPTION]: 'LinkedIn RSVP required.',
    [FACEBOOK_OPTION]: 'Continue with Facebook is required',
};

const ERROR_LINKEDIN_MESSAGE = 'Error: login with LinkedIn failed.';

const StyledRequiredMessage = styled.div`
    display: flex;
    justify-content: ${(props) => (props.selectedSocialNetwork === LINKEDIN_OPTION ? 'start' : 'center')};
    font-size: ${(props) => (props.selectedSocialNetwork === LINKEDIN_OPTION ? '100%' : '0.8rem')};
`;

const SocialRsvp = ({ selectedSocialNetwork, nodeId, isRequired }) => {
    const formMetaFromId = useSelector((state) =>
        getFormMetaFromId(state, {
            id: nodeId,
        }),
    );

    const requiredError = get(formMetaFromId, 'requiredError');
    const requiredMessage = requiredMessages[selectedSocialNetwork];

    return (
        <React.Fragment>
            {
                {
                    [LINKEDIN_OPTION]: <LinkedIn nodeId={nodeId} isRequired={isRequired} />,
                    [FACEBOOK_OPTION]: <Facebook nodeId={nodeId} isRequired={isRequired} />,
                }[selectedSocialNetwork]
            }

            {isRequired && (
                <StyledRequiredMessage selectedSocialNetwork={selectedSocialNetwork}>
                    {selectedSocialNetwork === FACEBOOK_OPTION && <RequiredAsterisk aria-required />}
                    <SocialRsvpRequiredMessage requiredMessage={requiredMessage} requiredError={requiredError} />
                </StyledRequiredMessage>
            )}
            {formMetaFromId && formMetaFromId.linkedIn && <FormErrorWithIcon message={ERROR_LINKEDIN_MESSAGE} />}
        </React.Fragment>
    );
};

SocialRsvp.propTypes = {
    nodeId: PropTypes.string.isRequired,
    isRequired: PropTypes.bool.isRequired,
    selectedSocialNetwork: PropTypes.string,
};

SocialRsvp.defaultProps = {
    selectedSocialNetwork: LINKEDIN_OPTION,
};

export default SocialRsvp;
